import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import {
  CanonicalTopicsCompressionDataSchema,
  DataResponse,
  GetBackofficeSupportTreemapSchema,
  TimeFrameEnum,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeSupportTreemapSchema>
type Response = DataResponse<z.infer<typeof CanonicalTopicsCompressionDataSchema>>

const getBackofficeSupportTreemapQueryKey = (query: Query) => [
  "backofficeSupportTreemap",
  query.query ?? "",
  query.timeFrame ?? TimeFrameEnum.Last1Week,
  query.domain,
  JSON.stringify(query.filterBy ?? {}),
]

type Props = {
  query: Query
}

export const getBackofficeSupportTreemapQuery = ({ query }: Props) => {
  return queryOptions({
    queryKey: getBackofficeSupportTreemapQueryKey(query),
    staleTime: 10 * MINUTES_TO_MILLIS,
    placeholderData: undefined,
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/support/treemap", {
        params: {
          query: query.query,
          filterBy: query.filterBy,
          timeFrame: query.timeFrame ?? TimeFrameEnum.Last1Week,
          domain: query.domain,
        },
      })
      return data.data
    },
  })
}
